import { render, staticRenderFns } from "./ExamManagementSuccess.vue?vue&type=template&id=641f5a44&scoped=true"
import script from "./ExamManagementSuccess.vue?vue&type=script&lang=js"
export * from "./ExamManagementSuccess.vue?vue&type=script&lang=js"
import style0 from "./ExamManagementSuccess.vue?vue&type=style&index=0&id=641f5a44&prod&lang=scss&scoped=true"
import style1 from "./ExamManagementSuccess.vue?vue&type=style&index=1&id=641f5a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f5a44",
  null
  
)

export default component.exports